import { render, staticRenderFns } from "./CyberboardR3.vue?vue&type=template&id=ca16cefa&scoped=true"
import script from "./CyberboardR3.vue?vue&type=script&lang=ts"
export * from "./CyberboardR3.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardR3.vue?vue&type=style&index=0&id=ca16cefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca16cefa",
  null
  
)

export default component.exports